
import PropTypes from 'prop-types';
import CustomTextInput from '../atoms/custom-text-input.atom';
import Content from '../atoms/content.atom';
import { useRef, useEffect } from 'react';

const PersonalInfoForm = ({
    isLoading,
    curp,
    rfc,
    homoclave,
    firstName,
    lastName,
    motherLastName,
    email,
    onCurpChange,
    onHomoclaveChange,
    onFirstNameChange,
    onLastNameChange,
    onMotherLastNameChange,
    onEmailChange,
    errors,
    informationRetrieved,
}) => {
    const isCurpValid = !errors.curp && curp.length === 18;

    return (
        <Content>
            <CustomTextInput
                label="CURP"
                placeholder="CURP"
                value={curp}
                onChange={onCurpChange}
                error={errors.curp}
                maxLength={18}
                inputContainerStyle={!isCurpValid ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                inputStyle={{ textTransform: 'uppercase' }}
            />
            <div style={{display: 'flex', flexDirection: 'row', width: '100%', gap: '16px'}}>
                <CustomTextInput
                    containerStyle={{width: '70%'}}
                    label="RFC"
                    placeholder="RFC"
                    value={rfc}
                    inputStyle={{ textTransform: 'uppercase' }}
                    disabled={true}
                />
                <CustomTextInput
                    containerStyle={{width: '30%', overflow: 'hidden'}}
                    label="Homoclave"
                    placeholder="Homoclave"
                    helper="Opcional"
                    value={homoclave}
                    onChange={onHomoclaveChange}
                    disabled={!isCurpValid}
                />
            </div>
            <CustomTextInput
                label="Nombre(s)"
                placeholder="Nombre(s)"
                value={firstName}
                onChange={onFirstNameChange}
                error={errors.firstName}
                inputContainerStyle={isCurpValid && !informationRetrieved ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                disabled={!isCurpValid || informationRetrieved || isLoading}
            />
            <CustomTextInput
                label="Apellido paterno"
                placeholder="Apellido paterno"
                value={lastName}
                onChange={onLastNameChange}
                error={errors.lastName}
                inputContainerStyle={isCurpValid && !informationRetrieved ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                disabled={!isCurpValid || informationRetrieved || isLoading}
            />
            <CustomTextInput
                label="Apellido materno"
                placeholder="Apellido materno"
                value={motherLastName}
                onChange={onMotherLastNameChange}
                error={errors.motherLastName}
                inputContainerStyle={isCurpValid && !informationRetrieved ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                disabled={!isCurpValid || informationRetrieved || isLoading}
            />
            <CustomTextInput
                label="Correo electrónico"
                placeholder="Correo electrónico"
                value={email}
                onChange={onEmailChange}
                error={errors.email}
                inputContainerStyle={isCurpValid ? {borderColor: '#FACE07', borderWidth: 2} : {}}
                disabled={!isCurpValid || isLoading}
            />
        </Content>
    );
};

PersonalInfoForm.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    curp: PropTypes.string,
    rfc: PropTypes.string,
    homoclave: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    motherLastName: PropTypes.string,
    email: PropTypes.string,
    onCurpChange: PropTypes.func,
    onHomoclaveChange: PropTypes.func,
    onFirstNameChange: PropTypes.func,
    onLastNameChange: PropTypes.func,
    onMotherLastNameChange: PropTypes.func,
    onEmailChange: PropTypes.func,
    errors: PropTypes.object,
    informationRetrieved: PropTypes.bool,
};

export default PersonalInfoForm; 